import { Location } from 'vue-router'
import { UserHistoryCollection as Collection } from '@/typings/api/User'

import { createView } from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import { USERS_ROUTES } from '@/views/Users/utils'
import { USERS_HISTORY_ROUTES as ROUTES } from './utils'

const getViewRoute = (data: Collection): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createView(getViewRoute),
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID пользователя',
    value: 'id',
    sortable: false,
    width: 130,
    getRoute: (data: Collection): Location => ({
      name: ROUTES.VIEW,
      params: { id: data.id.toString() },
    }),
  },
  {
    text: 'Пользователь',
    value: 'user',
    sortable: true,
    getRoute: (data: Collection): Location => ({
      name: USERS_ROUTES.VIEW,
      params: { id: data.user.id.toString() },
    }),
  },
  {
    text: 'Дата изменения',
    value: 'created_at',
    sortable: true,
    width: 152,
    field: (value: Collection['created_at']) => (
      value && dateFormatter(value)
    ),
  },
])
